import React, { memo } from 'react';

import { IconButton } from '../../helpers/IconButton';

const CheckboxComponent = ({ id, parentId, name, checked = false, collapsed, onChange, onClick }) => (
  <div className="checkbox">
    <label>
      <input checked={checked} onChange={() => onChange(id, parentId)} type="checkbox" />
      {name}
      {onClick && (
        <IconButton
          className="ml5"
          icon={collapsed ? 'caret-square-o-down' : 'caret-square-o-up'}
          onClick={event => {
            event.stopPropagation();
            event.preventDefault();
            onClick(id);
          }}
          size="sm"
          title={collapsed ? 'Click to expand' : 'Click to collapse'}
        />
      )}
    </label>
  </div>
);

export const Checkbox = memo(CheckboxComponent);
